import _ from 'lodash';

import * as types from '../constants/actionTypes';

export const clearForm = form => ({
  type: types.CLEAR_FORM,
  form,
});

export const updateField = (form, field, value) => ({
  type: types.UPDATE_FIELD,
  form,
  field,
  value,
});

export const addToGroup = (groupName, record) => ({
  type: types.ADD_TO_GROUP,
  groupName,
  record,
});

export const updateInGroup = (groupName, updatedRecord) => ({
  type: types.UPDATE_IN_GROUP,
  groupName,
  updatedRecord,
});

export const removeFromGroup = (groupName, recordIndex) => ({
  type: types.REMOVE_FROM_GROUP,
  groupName,
  recordIndex,
});

//

// TODO: confirm that this action is safe to remove
export const removeField = (field, ratingType) => ({
  type: types[`${_.snakeCase(ratingType).toUpperCase()}_REMOVE_FIELD`],
  field,
});

export const removeAllEngineFields = () => ({
  type: types.RATING_SELF_REMOVE_ENGINE_FIELDS,
});

export const removeNonHeaderFields = ratingType => ({
  type: types[`${_.snakeCase(ratingType).toUpperCase()}_REMOVE_NON_HEADER_FIELDS`],
});

// sagas
export const createDriverRating = (data, formType, redirectTo) => ({
  type: types.CREATE_DRIVER_RATING,
  data,
  formType,
  redirectTo,
});
export const fetchDriverRatingOptions = formType => ({
  type: types.FETCH_DRIVER_RATING_OPTIONS,
  formType,
});

// messages
export const createDriverRatingLoading = () => ({ type: types.CREATE_DRIVER_RATING_LOADING });
export const createDriverRatingError = () => ({ type: types.CREATE_DRIVER_RATING_ERROR });
export const createDriverRatingSuccess = data => ({
  type: types.CREATE_DRIVER_RATING_SUCCESS,
  data,
});
export const fetchDriverRatingOptionsLoading = () => ({ type: types.FETCH_DRIVER_RATING_OPTIONS_LOADING });
export const fetchDriverRatingOptionsError = () => ({ type: types.FETCH_DRIVER_RATING_OPTIONS_ERROR });
export const fetchDriverRatingOptionsSuccess = data => ({
  type: types.FETCH_DRIVER_RATING_OPTIONS_SUCCESS,
  data,
});

// sagas
export const createDriverSelfRating = (data, formType, redirectTo) => ({
  type: types.CREATE_DRIVER_SELF_RATING,
  data,
  formType,
  redirectTo,
});
export const fetchDriverSelfRatingOptions = formType => ({
  type: types.FETCH_DRIVER_SELF_RATING_OPTIONS,
  formType,
});

export const uploadProfileImage = (mime, blob) => ({
  type: types.UPLOAD_PROFILE_IMAGE,
  mime,
  blob,
});
export const deleteProfileImage = () => ({ type: types.DELETE_PROFILE_IMAGE });

export const uploadDocument = doc => ({
  type: types.UPLOAD_DOCUMENT,
  doc,
});
export const deleteDocument = () => ({ type: types.DELETE_DOCUMENT });

// messages
export const createDriverSelfRatingLoading = () => ({ type: types.CREATE_DRIVER_SELF_RATING_LOADING });
export const createDriverSelfRatingError = () => ({ type: types.CREATE_DRIVER_SELF_RATING_ERROR });
export const createDriverSelfRatingSuccess = data => ({
  type: types.CREATE_DRIVER_SELF_RATING_SUCCESS,
  data,
});
export const fetchDriverSelfRatingOptionsLoading = () => ({ type: types.FETCH_DRIVER_SELF_RATING_OPTIONS_LOADING });
export const fetchDriverSelfRatingOptionsError = () => ({ type: types.FETCH_DRIVER_SELF_RATING_OPTIONS_ERROR });
export const fetchDriverSelfRatingOptionsSuccess = data => ({
  type: types.FETCH_DRIVER_SELF_RATING_OPTIONS_SUCCESS,
  data,
});

export const uploadProfileImageLoading = () => ({ type: types.UPLOAD_PROFILE_IMAGE_LOADING });
export const uploadProfileImageError = () => ({ type: types.UPLOAD_PROFILE_IMAGE_ERROR });
export const uploadProfileImageSuccess = data => ({
  type: types.UPLOAD_PROFILE_IMAGE_SUCCESS,
  data,
});

export const deleteProfileImageLoading = () => ({ type: types.DELETE_PROFILE_IMAGE_LOADING });
export const deleteProfileImageError = () => ({ type: types.DELETE_PROFILE_IMAGE_ERROR });
export const deleteProfileImageSuccess = data => ({
  type: types.DELETE_PROFILE_IMAGE_SUCCESS,
  data,
});

export const uploadDocumentLoading = () => ({ type: types.UPLOAD_DOCUMENT_LOADING });
export const uploadDocumentError = () => ({ type: types.UPLOAD_DOCUMENT_ERROR });
export const uploadDocumentSuccess = data => ({
  type: types.UPLOAD_DOCUMENT_SUCCESS,
  data,
});

export const deleteDocumentLoading = () => ({ type: types.DELETE_DOCUMENT_LOADING });
export const deleteDocumentError = () => ({ type: types.DELETE_DOCUMENT_ERROR });
export const deleteDocumentSuccess = data => ({
  type: types.DELETE_DOCUMENT_SUCCESS,
  data,
});
